var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26951_21330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14272 0.571411C1.72256 0.571411 0.571289 1.72268 0.571289 3.14284V11.1428C0.571289 11.6162 0.955044 12 1.42843 12C1.90181 12 2.28557 11.6162 2.28557 11.1428V3.14284C2.28557 2.66946 2.66933 2.2857 3.14272 2.2857H11.1427C11.6161 2.2857 11.9999 1.90194 11.9999 1.42855C11.9999 0.955166 11.6161 0.571411 11.1427 0.571411H3.14272ZM5.14272 3.42855C4.19594 3.42855 3.42843 4.19606 3.42843 5.14284V13.7143C3.42843 14.661 4.19594 15.4286 5.14272 15.4286H13.7141C14.6609 15.4286 15.4284 14.661 15.4284 13.7143V5.14284C15.4284 4.19606 14.6609 3.42855 13.7141 3.42855H5.14272Z",
    fill: "#EB3366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26951_21330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRed);
export default __webpack_public_path__ + "static/media/copy-red.4f7d03b59600b12c37edc0fd4eb4c318.svg";
export { ForwardRef as ReactComponent };